import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { CROPS_PATH } from "../services/ServiceConstants";
// import config from 'react-native-config';

/**
 * HTTP methods supported by the service
 */
type HttpMethod = "get" | "post" | "put" | "delete" | "patch";

/**
 * Generic interface for API response
 */
interface ApiResponse<T> {
  data: T;
}

/**
 * Generic API service function
 * @param method - HTTP method (GET, POST, etc.)
 * @param url - API endpoint
 * @param data - Payload for POST, PUT, or PATCH requests
 * @returns - Generic type promise of the API response
 */
const apiService = async <T = any,>(
  method: HttpMethod,
  endpoint: string,
  data: Record<string, any> | null = null,
  hasAuthToken: boolean = false,
  tokenType?: string,
  token?: string
): Promise<ApiResponse<T>> => {
  const url = CROPS_PATH + endpoint;

  try {
    const config: AxiosRequestConfig = {
      method,
      url,
      data,
      headers: {
        "content-Type": "application/json",
        ...(hasAuthToken &&
          tokenType && {
            [tokenType]: `Bearer ${token}`,
            // Authorization: `Bearer ${token?.access_token}`,
          }) /** Update with actual token if needed */,
      },
    };
    // Remove the `data` field for GET requests
    if (method === "get") {
      delete config.data;
    }

    const response: AxiosResponse<T> = await axios(config);

    return { data: response.data };
  } catch (error: any) {
    return error;
  }
};

export default apiService;
